'use client';

import { useCookies } from 'next-client-cookies';
import { Product } from 'shared/types/product';
import { Facet } from 'shared/types/query';
import ProductListProvider from 'components/commercetools-ui/organisms/product/product-list/context';
import RelatedProductsBanner from 'components/commercetools-ui/organisms/product/related-products-banner';
import { RelatedProductsProps } from 'components/commercetools-ui/organisms/product/related-products-banner/types';
import { mapCategotry } from 'helpers/entity-mappers/map-category';
import { flattenTree } from 'helpers/utils/flattenTree';
import { DataSource } from 'types/datasource';
import { useWishlist } from 'frontastic/hooks';
import { TasticProps } from 'frontastic/tastics/types';

interface DataSourceProps {
  items: Product[];
  category: string;
  facets: Facet[];
  previousCursor?: string;
  nextCursor?: string;
  total: number;
  totalItems: number;
}

function RelatedProductsTastic({ data, categories }: TasticProps<DataSource<DataSourceProps> & RelatedProductsProps>) {
  
  const readonlyData = data;
  const readonlyCategories = categories as Readonly<typeof categories>;

  const { mobile, tablet, desktop, ...props } = readonlyData;

  const cookies = useCookies();
  const locale = cookies.get('locale') as string;
  const { data: wishlist, addToWishlist, removeLineItem } = useWishlist();
  const flattenedCategories = readonlyCategories.flatMap((category) => flattenTree(category, 'descendants'));
  return (
    <ProductListProvider
      categories={flattenedCategories.map((category) => mapCategotry(category, { locale }))}
      facetsConfiguration={{}}
      uiState={{
        totalItems: 0,
      }}
      wishlist={wishlist}
      addToWishlist={async (lineItem, count) => {
        if (wishlist) await addToWishlist(wishlist, lineItem, count);
      }}
      removeFromWishlist={async (lineItem) => {
        if (wishlist) await removeLineItem(wishlist, lineItem);
      }}
    >
      <RelatedProductsBanner {...props} categories={categories} />
    </ProductListProvider>
  );
}

export default RelatedProductsTastic;
